module.exports = __webpack_public_path__ + "img/8.a185de1e.png";